import {
  Companion_getInstancezuwazqbeik8p as Companion_getInstance,
  IncidentMessage1zg9aeg4hgwtu as IncidentMessage,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { IncidentResponseTypeSerializable3r9ni9dqtxaoj as IncidentResponseTypeSerializable } from './incidentResponse/serialization.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_incident(_this__u8e3s4) {
  return _this__u8e3s4.prop(IncidentMessage_incident_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(IncidentMessage_project_getInstance());
}
function get_created(_this__u8e3s4) {
  return _this__u8e3s4.prop(IncidentMessage_created_getInstance());
}
function prepareIncidentMessageFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [IncidentMessage__id_getInstance(), IncidentMessage_incident_getInstance(), IncidentMessage_project_getInstance(), IncidentMessage_clientMessage_getInstance(), IncidentMessage_sender_getInstance(), IncidentMessage_typeSerializable_getInstance(), IncidentMessage_message_getInstance(), IncidentMessage_attachments_getInstance(), IncidentMessage_created_getInstance(), IncidentMessage_readBy_getInstance(), IncidentMessage_needsResponse_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function IncidentMessage_incident$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function IncidentMessage_incident$_get_name_$ref_3fp0gn() {
  return (p0) => p0.k20();
}
function IncidentMessage_incident$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_incident$_get_serializer_$ref_drsl3k() {
  return (p0) => p0.j2j();
}
function IncidentMessage_incident$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function IncidentMessage_incident$_get_annotations_$ref_gumwq4() {
  return (p0) => p0.bz();
}
var IncidentMessage_incidentClass;
function IncidentMessage_incident() {
  if (IncidentMessage_incidentClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_incident_instance = this;
        var tmp = this;
        tmp.s67_1 = lazy(IncidentMessage_incident$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t67_1 = lazy(IncidentMessage_incident$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u67_1 = lazy(IncidentMessage_incident$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.s67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_incident$_get_name_$ref_3fp0gn(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.x67_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      i68(receiver, value) {
        return receiver.j68(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.i68(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.t67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_incident$_get_serializer_$ref_drsl3k(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u67_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_incident$_get_annotations_$ref_gumwq4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_incident', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_incidentClass = $;
  }
  return IncidentMessage_incidentClass;
}
var IncidentMessage_incident_instance;
function IncidentMessage_incident_getInstance() {
  if (IncidentMessage_incident_instance === VOID)
    new (IncidentMessage_incident())();
  return IncidentMessage_incident_instance;
}
function IncidentMessage_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function IncidentMessage_project$_get_name_$ref_sil9dw() {
  return (p0) => p0.k20();
}
function IncidentMessage_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_project$_get_serializer_$ref_bmcfq5() {
  return (p0) => p0.j2j();
}
function IncidentMessage_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function IncidentMessage_project$_get_annotations_$ref_b0jsvt() {
  return (p0) => p0.bz();
}
var IncidentMessage_projectClass;
function IncidentMessage_project() {
  if (IncidentMessage_projectClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_project_instance = this;
        var tmp = this;
        tmp.k68_1 = lazy(IncidentMessage_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l68_1 = lazy(IncidentMessage_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m68_1 = lazy(IncidentMessage_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.k68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_project$_get_name_$ref_sil9dw(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.y67_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      i68(receiver, value) {
        return receiver.j68(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.i68(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_project$_get_serializer_$ref_bmcfq5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_project$_get_annotations_$ref_b0jsvt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_project', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_projectClass = $;
  }
  return IncidentMessage_projectClass;
}
var IncidentMessage_project_instance;
function IncidentMessage_project_getInstance() {
  if (IncidentMessage_project_instance === VOID)
    new (IncidentMessage_project())();
  return IncidentMessage_project_instance;
}
function IncidentMessage_created$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function IncidentMessage_created$_get_name_$ref_o9bi1h() {
  return (p0) => p0.k20();
}
function IncidentMessage_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_created$_get_serializer_$ref_avk8q6() {
  return (p0) => p0.j2j();
}
function IncidentMessage_created$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function IncidentMessage_created$_get_annotations_$ref_y2ttuy() {
  return (p0) => p0.bz();
}
var IncidentMessage_createdClass;
function IncidentMessage_created() {
  if (IncidentMessage_createdClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_created_instance = this;
        var tmp = this;
        tmp.n68_1 = lazy(IncidentMessage_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o68_1 = lazy(IncidentMessage_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p68_1 = lazy(IncidentMessage_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.q68_1 = get_default(Companion_instance).d1m();
        this.r68_1 = 'now()';
      }
      k20() {
        var tmp0 = this.n68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_created$_get_name_$ref_o9bi1h(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.e68_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      s68(receiver, value) {
        return receiver.j68(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.s68(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_created$_get_serializer_$ref_avk8q6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_created$_get_annotations_$ref_y2ttuy(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_created', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_createdClass = $;
  }
  return IncidentMessage_createdClass;
}
var IncidentMessage_created_instance;
function IncidentMessage_created_getInstance() {
  if (IncidentMessage_created_instance === VOID)
    new (IncidentMessage_created())();
  return IncidentMessage_created_instance;
}
function IncidentMessage__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function IncidentMessage__id$_get_name_$ref_aq5xxf() {
  return (p0) => p0.k20();
}
function IncidentMessage__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage__id$_get_serializer_$ref_m61ppg() {
  return (p0) => p0.j2j();
}
function IncidentMessage__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function IncidentMessage__id$_get_annotations_$ref_6zycbs() {
  return (p0) => p0.bz();
}
var IncidentMessage__idClass;
function IncidentMessage__id() {
  if (IncidentMessage__idClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage__id_instance = this;
        var tmp = this;
        tmp.t68_1 = lazy(IncidentMessage__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u68_1 = lazy(IncidentMessage__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v68_1 = lazy(IncidentMessage__id$annotations$delegate$lambda);
        this.w68_1 = Companion_getInstance_0().m2p();
        this.x68_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.t68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage__id$_get_name_$ref_aq5xxf(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.w67_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      i68(receiver, value) {
        return receiver.j68(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.i68(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage__id$_get_serializer_$ref_m61ppg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage__id$_get_annotations_$ref_6zycbs(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage__id', VOID, VOID, [SerializableProperty()]);
    IncidentMessage__idClass = $;
  }
  return IncidentMessage__idClass;
}
var IncidentMessage__id_instance;
function IncidentMessage__id_getInstance() {
  if (IncidentMessage__id_instance === VOID)
    new (IncidentMessage__id())();
  return IncidentMessage__id_instance;
}
function IncidentMessage_clientMessage$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function IncidentMessage_clientMessage$_get_name_$ref_196r7l() {
  return (p0) => p0.k20();
}
function IncidentMessage_clientMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_clientMessage$_get_serializer_$ref_p7g2w6() {
  return (p0) => p0.j2j();
}
function IncidentMessage_clientMessage$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function IncidentMessage_clientMessage$_get_annotations_$ref_g6ayhi() {
  return (p0) => p0.bz();
}
var IncidentMessage_clientMessageClass;
function IncidentMessage_clientMessage() {
  if (IncidentMessage_clientMessageClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_clientMessage_instance = this;
        var tmp = this;
        tmp.y68_1 = lazy(IncidentMessage_clientMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z68_1 = lazy(IncidentMessage_clientMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a69_1 = lazy(IncidentMessage_clientMessage$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.y68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_clientMessage$_get_name_$ref_196r7l(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.z67_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      b69(receiver, value) {
        return receiver.j68(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.b69(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z68_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_clientMessage$_get_serializer_$ref_p7g2w6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_clientMessage$_get_annotations_$ref_g6ayhi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_clientMessage', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_clientMessageClass = $;
  }
  return IncidentMessage_clientMessageClass;
}
var IncidentMessage_clientMessage_instance;
function IncidentMessage_clientMessage_getInstance() {
  if (IncidentMessage_clientMessage_instance === VOID)
    new (IncidentMessage_clientMessage())();
  return IncidentMessage_clientMessage_instance;
}
function IncidentMessage_sender$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function IncidentMessage_sender$_get_name_$ref_3xnl8() {
  return (p0) => p0.k20();
}
function IncidentMessage_sender$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_sender$_get_serializer_$ref_3x0wtp() {
  return (p0) => p0.j2j();
}
function IncidentMessage_sender$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function IncidentMessage_sender$_get_annotations_$ref_yaz52v() {
  return (p0) => p0.bz();
}
var IncidentMessage_senderClass;
function IncidentMessage_sender() {
  if (IncidentMessage_senderClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_sender_instance = this;
        var tmp = this;
        tmp.c69_1 = lazy(IncidentMessage_sender$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d69_1 = lazy(IncidentMessage_sender$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e69_1 = lazy(IncidentMessage_sender$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.c69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_sender$_get_name_$ref_3xnl8(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.a68_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      i68(receiver, value) {
        return receiver.j68(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.i68(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_sender$_get_serializer_$ref_3x0wtp(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_sender$_get_annotations_$ref_yaz52v(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_sender', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_senderClass = $;
  }
  return IncidentMessage_senderClass;
}
var IncidentMessage_sender_instance;
function IncidentMessage_sender_getInstance() {
  if (IncidentMessage_sender_instance === VOID)
    new (IncidentMessage_sender())();
  return IncidentMessage_sender_instance;
}
function IncidentMessage_typeSerializable$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function IncidentMessage_typeSerializable$_get_name_$ref_iktw6o() {
  return (p0) => p0.k20();
}
function IncidentMessage_typeSerializable$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_typeSerializable$_get_serializer_$ref_mo7fnt() {
  return (p0) => p0.j2j();
}
function IncidentMessage_typeSerializable$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function IncidentMessage_typeSerializable$_get_annotations_$ref_nkf4rp() {
  return (p0) => p0.bz();
}
var IncidentMessage_typeSerializableClass;
function IncidentMessage_typeSerializable() {
  if (IncidentMessage_typeSerializableClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_typeSerializable_instance = this;
        var tmp = this;
        tmp.f69_1 = lazy(IncidentMessage_typeSerializable$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g69_1 = lazy(IncidentMessage_typeSerializable$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h69_1 = lazy(IncidentMessage_typeSerializable$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.f69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_typeSerializable$_get_name_$ref_iktw6o(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.b68_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      i69(receiver, value) {
        return receiver.j68(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.i69(tmp, value instanceof IncidentResponseTypeSerializable() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_typeSerializable$_get_serializer_$ref_mo7fnt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_typeSerializable$_get_annotations_$ref_nkf4rp(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_typeSerializable', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_typeSerializableClass = $;
  }
  return IncidentMessage_typeSerializableClass;
}
var IncidentMessage_typeSerializable_instance;
function IncidentMessage_typeSerializable_getInstance() {
  if (IncidentMessage_typeSerializable_instance === VOID)
    new (IncidentMessage_typeSerializable())();
  return IncidentMessage_typeSerializable_instance;
}
function IncidentMessage_message$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function IncidentMessage_message$_get_name_$ref_hukuu() {
  return (p0) => p0.k20();
}
function IncidentMessage_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_message$_get_serializer_$ref_vpycfj() {
  return (p0) => p0.j2j();
}
function IncidentMessage_message$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function IncidentMessage_message$_get_annotations_$ref_r6p4sr() {
  return (p0) => p0.bz();
}
var IncidentMessage_messageClass;
function IncidentMessage_message() {
  if (IncidentMessage_messageClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_message_instance = this;
        var tmp = this;
        tmp.j69_1 = lazy(IncidentMessage_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k69_1 = lazy(IncidentMessage_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l69_1 = lazy(IncidentMessage_message$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.j69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_message$_get_name_$ref_hukuu(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.c68_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      m69(receiver, value) {
        return receiver.j68(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.m69(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_message$_get_serializer_$ref_vpycfj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_message$_get_annotations_$ref_r6p4sr(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_message', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_messageClass = $;
  }
  return IncidentMessage_messageClass;
}
var IncidentMessage_message_instance;
function IncidentMessage_message_getInstance() {
  if (IncidentMessage_message_instance === VOID)
    new (IncidentMessage_message())();
  return IncidentMessage_message_instance;
}
function IncidentMessage_attachments$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function IncidentMessage_attachments$_get_name_$ref_bpomrx() {
  return (p0) => p0.k20();
}
function IncidentMessage_attachments$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_attachments$_get_serializer_$ref_wba3ja() {
  return (p0) => p0.j2j();
}
function IncidentMessage_attachments$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function IncidentMessage_attachments$_get_annotations_$ref_8tkski() {
  return (p0) => p0.bz();
}
var IncidentMessage_attachmentsClass;
function IncidentMessage_attachments() {
  if (IncidentMessage_attachmentsClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_attachments_instance = this;
        var tmp = this;
        tmp.n69_1 = lazy(IncidentMessage_attachments$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o69_1 = lazy(IncidentMessage_attachments$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p69_1 = lazy(IncidentMessage_attachments$annotations$delegate$lambda);
        this.q69_1 = emptyList();
        this.r69_1 = 'emptyList()';
      }
      k20() {
        var tmp0 = this.n69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_attachments$_get_name_$ref_bpomrx(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.d68_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      s69(receiver, value) {
        return receiver.j68(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.s69(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_attachments$_get_serializer_$ref_wba3ja(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_attachments$_get_annotations_$ref_8tkski(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_attachments', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_attachmentsClass = $;
  }
  return IncidentMessage_attachmentsClass;
}
var IncidentMessage_attachments_instance;
function IncidentMessage_attachments_getInstance() {
  if (IncidentMessage_attachments_instance === VOID)
    new (IncidentMessage_attachments())();
  return IncidentMessage_attachments_instance;
}
function IncidentMessage_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function IncidentMessage_readBy$_get_name_$ref_p7rkzo() {
  return (p0) => p0.k20();
}
function IncidentMessage_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_readBy$_get_serializer_$ref_omr3fv() {
  return (p0) => p0.j2j();
}
function IncidentMessage_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function IncidentMessage_readBy$_get_annotations_$ref_1n7kjz() {
  return (p0) => p0.bz();
}
var IncidentMessage_readByClass;
function IncidentMessage_readBy() {
  if (IncidentMessage_readByClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_readBy_instance = this;
        var tmp = this;
        tmp.t69_1 = lazy(IncidentMessage_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u69_1 = lazy(IncidentMessage_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v69_1 = lazy(IncidentMessage_readBy$annotations$delegate$lambda);
        this.w69_1 = emptySet();
        this.x69_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.t69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_readBy$_get_name_$ref_p7rkzo(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.f68_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      y69(receiver, value) {
        return receiver.j68(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.y69(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_readBy$_get_serializer_$ref_omr3fv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_readBy$_get_annotations_$ref_1n7kjz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_readBy', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_readByClass = $;
  }
  return IncidentMessage_readByClass;
}
var IncidentMessage_readBy_instance;
function IncidentMessage_readBy_getInstance() {
  if (IncidentMessage_readBy_instance === VOID)
    new (IncidentMessage_readBy())();
  return IncidentMessage_readBy_instance;
}
function IncidentMessage_needsResponse$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function IncidentMessage_needsResponse$_get_name_$ref_wfaqin() {
  return (p0) => p0.k20();
}
function IncidentMessage_needsResponse$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentMessage_needsResponse$_get_serializer_$ref_3ad2e0() {
  return (p0) => p0.j2j();
}
function IncidentMessage_needsResponse$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function IncidentMessage_needsResponse$_get_annotations_$ref_esfxkc() {
  return (p0) => p0.bz();
}
var IncidentMessage_needsResponseClass;
function IncidentMessage_needsResponse() {
  if (IncidentMessage_needsResponseClass === VOID) {
    class $ {
      constructor() {
        IncidentMessage_needsResponse_instance = this;
        var tmp = this;
        tmp.z69_1 = lazy(IncidentMessage_needsResponse$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a6a_1 = lazy(IncidentMessage_needsResponse$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b6a_1 = lazy(IncidentMessage_needsResponse$annotations$delegate$lambda);
        this.c6a_1 = true;
        this.d6a_1 = 'true';
      }
      k20() {
        var tmp0 = this.z69_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentMessage_needsResponse$_get_name_$ref_wfaqin(), null);
        return tmp0.f2();
      }
      v67(receiver) {
        return receiver.g68_1;
      }
      m2j(receiver) {
        return this.v67(receiver instanceof IncidentMessage() ? receiver : THROW_CCE());
      }
      b69(receiver, value) {
        return receiver.j68(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentMessage() ? receiver : THROW_CCE();
        return this.b69(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentMessage_needsResponse$_get_serializer_$ref_3ad2e0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentMessage_needsResponse$_get_annotations_$ref_esfxkc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentMessage_needsResponse', VOID, VOID, [SerializableProperty()]);
    IncidentMessage_needsResponseClass = $;
  }
  return IncidentMessage_needsResponseClass;
}
var IncidentMessage_needsResponse_instance;
function IncidentMessage_needsResponse_getInstance() {
  if (IncidentMessage_needsResponse_instance === VOID)
    new (IncidentMessage_needsResponse())();
  return IncidentMessage_needsResponse_instance;
}
//region block: exports
export {
  get_created as get_createdoru21mxgd9ia,
  get_incident as get_incident3optryi02ng66,
  prepareIncidentMessageFields as prepareIncidentMessageFields3j9u9bef4r284,
  get_project as get_project3c9djjff48j0d,
};
//endregion

//# sourceMappingURL=IncidentMessageFields.mjs.map
